'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var Twine = require('twine');
var Breakpoints = require('../../global/breakpoints');
var StatefulForm = require('../stateful-form');
var FormsAPI = require('../forms-api');
var signupTracker = require('./signup-tracker');
require('./signup-hidden-fields');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var Twine__default = /*#__PURE__*/_interopDefaultLegacy(Twine);
var Breakpoints__default = /*#__PURE__*/_interopDefaultLegacy(Breakpoints);
var StatefulForm__default = /*#__PURE__*/_interopDefaultLegacy(StatefulForm);
var FormsAPI__default = /*#__PURE__*/_interopDefaultLegacy(FormsAPI);
var signupTracker__default = /*#__PURE__*/_interopDefaultLegacy(signupTracker);

class SignupForm extends StatefulForm__default {
  constructor(form, i18nNamespace) {
    super(form, i18nNamespace);
    this.breakpoints = new Breakpoints__default();

    function shopNameValidation(value) {
      const password = this.fields.password.state.value;
      const skipDomainValidation = this.fields.hasOwnProperty('subdomain');
      return FormsAPI__default.validateShopName(password, value, skipDomainValidation);
    }

    function shopSubdomainValidation(value) {
      return FormsAPI__default.subdomainAvailable(value);
    }

    function promotionalProgramPromoCodeValidation(value) {
      const promotionalProgramCode = this.$form.promotional_program_code.value;
      return FormsAPI__default.promotionalProgramPromoCodeAvailable(promotionalProgramCode, value);
    }

    this.validationFns.shop_name = shopNameValidation.bind(this); // eslint-disable-line babel/camelcase

    this.validationFns.subdomain = shopSubdomainValidation.bind(this);
    this.validationFns.promotional_program_promo_code = promotionalProgramPromoCodeValidation.bind(this); // eslint-disable-line babel/camelcase

    this.pending = false;
  }

  getHiddenFields() {
    return ShopifyMarketing.context[this.$form.dataset.hiddenFieldsNamespace];
  }

  handleSubmit(...args) {
    var _superprop_getHandleSubmit = () => super.handleSubmit,
        _this = this;

    return _asyncToGenerator__default(function* () {
      _this.pending = true;
      Twine__default.refresh();

      const hiddenFields = _this.getHiddenFields();

      if (hiddenFields) {
        // This will set hidden input value via Twine refresh that gets triggered
        // on submit.
        hiddenFields.setField('y', hiddenFields.y());
      }

      try {
        yield _superprop_getHandleSubmit().call(_this, args);
      } finally {
        _this.pending = false;
      }
    })();
  }

  preSubmitHook() {
    const event = signupTracker__default.analyticsEvents.success;
    const tealiumContext = {
      emailAddress: this.fields.email.state.value,
      shopName: this.fields.shop_name.state.value
    };
    return signupTracker__default.trackSuccess(event, tealiumContext);
  }

  populateEmail(value) {
    var _this2 = this;

    return _asyncToGenerator__default(function* () {
      const emailField = _this2.fields.email;
      emailField.setState({
        value
      });
      emailField.handleBlur();

      try {
        yield _this2.validateFieldIfSet(emailField); // eslint-disable-next-line no-empty
      } catch (error) {}

      if (!emailField.state.value || emailField.state.error) {
        _this2.focusOnField('email');
      } else if (_this2.breakpoints.matches('tabletUp')) {
        _this2.focusOnField('password');
      }
    })();
  }

  fieldErrorHook(field) {
    if (!field.state.error) {
      return;
    }

    signupTracker__default.sendGAEvent(`error_${field.name}`);
    signupTracker__default.trackError(field.name, field.state.errors, field.state.value);
  }

  handleEmailSuggestionClick() {
    const emailField = this.fields.email;
    signupTracker__default.sendGAEvent('mailcheck');
    emailField.setState({
      value: emailField.state.suggestion.full,
      hint: false
    });
  }

}

Twine__default.register('SignupForm', SignupForm);

exports.default = SignupForm;
